import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAdd, SearchNormal1, People } from "iconsax-react";
import PageHeader from "../../../components/PageHeader";
import TeacherItem from "../../../components/TeacherItem";
import { useProfiles, DataTypeProfile } from "../../../hooks/profile";
import { useAuth } from "../../../hooks/auth";
import Footer from "../../../components/Footer";
import Breadcrumb from "../../../components/Breadcrumb";
import {
  Container,
  FilterBar,
  FilterGroup,
  SearchWrapper,
  SearchInput,
  SelectFilter,
  AddButton,
  Main,
  EmptyState,
  TotalBadge,
} from "./styles";

const DAYS = [
  { value: "", label: "Todos os dias" },
  { value: "0", label: "Domingo" },
  { value: "1", label: "Segunda-Feira" },
  { value: "2", label: "Terça-Feira" },
  { value: "3", label: "Quarta-Feira" },
  { value: "4", label: "Quinta-Feira" },
  { value: "5", label: "Sexta-Feira" },
  { value: "6", label: "Sábado" },
];

const SUBJECTS = [
  { value: "", label: "Todas as matérias" },
  { value: "Libras", label: "Libras" },
  { value: "Inglês", label: "Inglês" },
  { value: "Matemática", label: "Matemática" },
];

function TeacherList() {
  const navigate = useNavigate();
  const { getProfiles } = useProfiles();
  const [profiles, setProfiles] = useState<DataTypeProfile[]>([]);
  const [search, setSearch] = useState("");
  const [dayFilter, setDayFilter] = useState("");
  const [subjectFilter, setSubjectFilter] = useState("");

  const { user } = useAuth();
  useEffect(() => {
    if (user && user.type !== "admin" && !user.isAdmin) {
      navigate("/403");
    }
  }, [user, navigate]);

  useEffect(() => {
    async function loadData() {
      if (!user?.uid) return;
      try {
        const teachers = await getProfiles();
        setProfiles(teachers);
      } catch (error) {
        console.error("Failed to load teachers:", error);
      }
    }
    loadData();
  }, [getProfiles, user?.uid]);

  const filtered = profiles.filter((s: any) => {
    const matchSearch =
      !search || s.name?.toLowerCase().includes(search.toLowerCase());
    const matchSubject =
      !subjectFilter ||
      s.subject?.toLowerCase() === subjectFilter.toLowerCase();
    return matchSearch && matchSubject;
  });

  return (
    <Container id="page-teacher-list">
      <PageHeader
        title="Gerenciamento de Professores."
        description="Acompanhe os professores cadastrados na plataforma"
        type="manager"
      />

      <FilterBar>
        <FilterGroup>
          <SearchWrapper>
            <SearchNormal1 size={18} color="var(--color-primary)" />
            <SearchInput
              placeholder="Buscar professor..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </SearchWrapper>

          <SelectFilter
            value={subjectFilter}
            onChange={(e) => setSubjectFilter(e.target.value)}
          >
            {SUBJECTS.map((s) => (
              <option key={s.value} value={s.value}>
                {s.label}
              </option>
            ))}
          </SelectFilter>

          <SelectFilter
            value={dayFilter}
            onChange={(e) => setDayFilter(e.target.value)}
          >
            {DAYS.map((d) => (
              <option key={d.value} value={d.value}>
                {d.label}
              </option>
            ))}
          </SelectFilter>
        </FilterGroup>

        <AddButton type="button" onClick={() => navigate("/give-classes")}>
          <UserAdd size={18} color="currentColor" />
          Novo Professor
        </AddButton>
      </FilterBar>

      <Main>
        <Breadcrumb
          items={[
            { label: "Gerenciamento", link: "/manager" },
            { label: "Professores", active: true },
          ]}
        />
        {filtered.length > 0 && (
          <TotalBadge>
            <People size={16} />
            {filtered.length === 1
              ? "1 professor encontrado"
              : `${filtered.length} professores encontrados`}
          </TotalBadge>
        )}

        {filtered.length === 0 ? (
          <EmptyState>
            <People size={64} color="var(--color-primary-lighter)" />
            <h2>Nenhum professor encontrado</h2>
            <p>
              {profiles.length === 0
                ? "Comece cadastrando seu primeiro professor."
                : "Tente ajustar os filtros de busca."}
            </p>
            <button type="button" onClick={() => navigate("/give-classes")}>
              <UserAdd size={18} />
              Cadastrar Professor
            </button>
          </EmptyState>
        ) : (
          <div className="grid">
            {filtered.map((student: any) => (
              <TeacherItem key={student.uid} data={student} />
            ))}
          </div>
        )}
      </Main>

      <Footer />
    </Container>
  );
}

export default TeacherList;
